/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkPricePatchRequest } from '../../models/bulk-price-patch-request';
import { BulkPricePatchResponse } from '../../models/bulk-price-patch-response';

export interface BulkPricePatch$Params {
      body: BulkPricePatchRequest
}

export function bulkPricePatch(http: HttpClient, rootUrl: string, params: BulkPricePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkPricePatchResponse>> {
  const rb = new RequestBuilder(rootUrl, bulkPricePatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkPricePatchResponse>;
    })
  );
}

bulkPricePatch.PATH = '/discounts/bulk-patch-by-price-steps';
